import { useSource } from 'AurionCR/components';
import { USERS_MAP_SOURCE, type UserMapEntry } from './helpers';

export function useUsersMapLookup() {
  return useSource<UserMapEntry>(USERS_MAP_SOURCE, 'userID', true);
}
